import {
  UserPlusIcon,
  MegaphoneIcon,
  ArrowUpTrayIcon,
  WrenchScrewdriverIcon,
  UserGroupIcon,
  EyeSlashIcon,
  MapPinIcon,
  ClockIcon,
  Squares2X2Icon,
  DocumentTextIcon,
  PresentationChartLineIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Sales and Customer Dashboard",
    href: "/lead-generation/sales-and-customer-dashboard",
    icon: Squares2X2Icon,
    current: false,
    internalName: "dashboard",
    permissions: ["stochastic-dashboard"],
  },
  {
    name: "ROI Dashboard",
    href: "/lead-generation/roi-dashboard",
    icon: PresentationChartLineIcon,
    current: false,
    internalName: "roi_dashboard",
    permissions: ["stochastic-roi-dashboard"],
  },
  {
    name: "Total Addressable Market",
    href: "/lead-generation/total-addressable-market",
    icon: GlobeAltIcon,
    current: false,
    internalName: "total_addressable_market",
    permissions: ["stochastic-total-addressable-market"],
  },
  {
    name: "Prospects",
    href: "/lead-generation/prospects",
    icon: UserPlusIcon,
    current: false,
    internalName: "prospects",
    permissions: ["stochastic-prospects"],
  },
  {
    name: "Customers",
    href: "/lead-generation/customers",
    icon: UserGroupIcon,
    current: false,
    internalName: "customers",
    permissions: ["stochastic-customers"],
  },
  {
    name: "Invoices",
    href: "/lead-generation/invoices",
    icon: DocumentTextIcon,
    current: false,
    internalName: "invoices",
    permissions: ["stochastic-invoices"],
  },
  {
    name: "Locations",
    href: "/lead-generation/locations",
    icon: MapPinIcon,
    current: false,
    internalName: "locations",
    permissions: ["stochastic-locations"],
  },
  {
    name: "Campaign Management",
    href: "/lead-generation/campaigns",
    icon: MegaphoneIcon,
    current: false,
    internalName: "campaigns",
    permissions: ["stochastic-campaign-management"],
  },
  {
    name: "Uploads",
    href: "#",
    icon: ArrowUpTrayIcon,
    current: false,
    internalName: "dashboards",
    permissions: ["stochastic-uploads"],
    children: [
      {
        name: "Field Service Import",
        href: "/lead-generation/field-service-import",
        icon: WrenchScrewdriverIcon,
        current: false,
        internalName: "field_service_import",
        permissions: ["stochastic-uploads"],
      },
      {
        name: "Prospect Source Import",
        href: "/lead-generation/prospect-source-import",
        icon: UserPlusIcon,
        current: false,
        internalName: "prospect_source_import",
        permissions: ["stochastic-uploads"],
      },
      {
        name: "Do Not Mail Import",
        href: "/lead-generation/do-not-mail-import",
        icon: EyeSlashIcon,
        current: false,
        internalName: "do_not_mail_import",
        permissions: ["stochastic-uploads"],
      },
      {
        name: "Import Status",
        href: "/lead-generation/import-status",
        icon: ClockIcon,
        current: false,
        internalName: "import_status",
        permissions: ["stochastic-uploads"],
      },
    ],
  },
];

const stochasticConfig = {
  sectionName: "stochastic",
  defaultRoute: "/lead-generation/sales-and-customer-dashboard",
  navigation,
};

export default stochasticConfig;
